import { render, staticRenderFns } from "./HomeOld.vue?vue&type=template&id=c25f8aa0&scoped=true"
import script from "./HomeOld.vue?vue&type=script&lang=js"
export * from "./HomeOld.vue?vue&type=script&lang=js"
import style0 from "./HomeOld.vue?vue&type=style&index=0&id=c25f8aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25f8aa0",
  null
  
)

export default component.exports